/* eslint-disable @typescript-eslint/no-unused-vars */
import { Step, StepLabel, Stepper } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import lang from '../../../../constants/leng';
import useEffectOnce from '../../../../hooks/useEffectOnce';
import { selectSelectedLanguage } from '../../../store/language/selectors';
import { registerFormSteps } from '../constants';

interface IFormCard {
  children: JSX.Element;
  currentStep: number;
  activeStep: number;
  setActiveStep: (value: number) => void;
  steps: string[];
}

const FormCard = ({
  children,
  currentStep,
  activeStep,
  steps,
  setActiveStep,
}: IFormCard) => {
  const { language } = useSelector(selectSelectedLanguage);

  const cssClasses = {
    stepClasses: '!p-0',
  };

  const [completed, setCompleted] = React.useState<number>(0);

  const handleReset = () => {
    setCompleted(0);
  };

  useEffectOnce(() => {
    handleReset();
  });

  useEffect(() => {
    setCompleted(currentStep);
  }, [currentStep]);

  return (
    <>
      {currentStep !== registerFormSteps.CONTACT_CONFIRMATION && (
        <div className="flex flex-row gap-4 w-full justify-around py-3">
          <Stepper
            className="w-full max-w-[300px]"
            nonLinear
            activeStep={activeStep}
            sx={{
              justifyContent: steps.length > 1 ? 'left' : ' center',
              '.MuiStepConnector-line': {
                borderColor: '#E8F3FF',
                borderWidth: '2px',
              },
              'svg:not(.Mui-active)': {
                color: '#E8F3FF',
              },
              'svg.Mui-completed': {
                color: '#4DB6AC',
              },
            }}
          >
            {steps.map((label, index) => (
              <Step
                className={cssClasses.stepClasses}
                key={label}
                completed={index < completed}
              >
                <StepLabel
                  sx={{
                    '.MuiStepLabel-iconContainer': {
                      padding: '5px',
                    },
                  }}
                  color="inherit"
                />
              </Step>
            ))}
          </Stepper>
        </div>
      )}
      {children}
    </>
  );
};
export default FormCard;
